import React from 'react';
import { Typography, useTheme } from '@mui/material';

import { sxStyled } from '../styles';

const NumberOfPassengers = ({ adults, childs, childsBaby }) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const renderPassengerText = (count, singular, plural) => {
    if (count <= 0) return null;
    return (
      <Typography sx={sxStyle.priceConcept}>
        {count} {count === 1 ? singular : plural}
      </Typography>
    );
  };

  return (
    <>
      {renderPassengerText(adults, 'Adulto', 'Adultos')}
      {renderPassengerText(childs, 'Menor', 'Menores')}
      {renderPassengerText(childsBaby, 'Infante', 'Infantes')}
    </>
  );
};

export default NumberOfPassengers;
